import Immutable from 'immutable';
import { proxy, genAction } from '../helpers/util';

let expression = '', expressionCode = '', billNo = null, entityName = null, treeData = null, key2Data = null, selectedKey2Title = null, title2ResultKey = null, selectionStart = 0;

const $$initialState = Immutable.fromJS({
  visible: false,
  caption: '',
  expression,
  expressionCode,
  cName: "",
  bCanModify: false,
  custom: {
    enums: null,
    data: null,
    enumval: "",
    codeId: '',
    defaultrefer: '',
    returnval: []
  },
  errorInfo: '',
  checkPass: false,
  cControlType: 'Input',
  cFormatData: null,
  iNumPoint: 0,
});

export default ($$state = $$initialState, action) => {
  switch (action.type) {
    case 'PLATFORM_UI_FORMULA_INIT_DATA':
      return $$state.merge(action.payload);
    case 'PLATFORM_UI_FORMULA_UPDATE_EXPRESSION':
      return $$state.set('expression', expression).merge(action.payload);
    case 'PLATFORM_ENUM_MERGE_DATA':
      let custom = Object.assign($$state.get('custom').toJS(), action.payload);
      return $$state.set('custom', Immutable.fromJS(custom));//setIn(['custom', payload.type], payload.data);
    case 'PLATFORM_CLEAR_MERGE_DATA':
      return $$state.merge({
        custom: {
          enums: null,
          data: null,
          enumval: "",
          codeId: '',
          defaultrefer: '',
          returnval: []
        }
      });
    default:
      return $$state;
  }
}

export function setCommonData(data) {
  return function (dispatch) {
    dispatch(genAction('PLATFORM_UI_FORMULA_INIT_DATA', data));
  }
}

export function select(key) {
  return function (dispatch,getState) {
    let {cBillType} = getState().billDesign.toJS();
    let tempCanModify = false;
    let tempKeys = (key || '').split('.');
    treeData.find((item) => {
      if (item.name === tempKeys[0]) {
        if (tempKeys.length > 1) {
          item.children.find((titem) => {
            if (titem.name === tempKeys[1]) {
              if ((titem.bCanModify !== undefined && titem.bCanModify !== null)) {
                tempCanModify = titem.bCanModify === 'true';
              } else {
                tempCanModify = item.bCanModify === 'true';
              }
            }
          })
        } else {
          tempCanModify = item.bCanModify === 'true';
        }
      }
    })

    if(cBillType==='Report'){
      tempCanModify=false;
    }
    const leftExp = expression.substr(0, selectionStart);
    const rightExp = expression.substr(selectionStart);
    expression = leftExp + selectedKey2Title[key] + rightExp;
    selectionStart = expression.length;
    dispatch(genAction('PLATFORM_UI_FORMULA_UPDATE_EXPRESSION', { bCanModify: tempCanModify }));
  }
}

export function selectOperator(key) {
  return function (dispatch) {
    const leftExp = expression.substr(0, selectionStart);
    const rightExp = expression.substr(selectionStart);
    expression = leftExp + key + rightExp;
    selectionStart = expression.length;
    dispatch(genAction('PLATFORM_UI_FORMULA_UPDATE_EXPRESSION'));
  }
}

export function changeCaption(value) {
  return genAction('PLATFORM_UI_FORMULA_INIT_DATA', { caption: value });
}

export function change(value, start) {
  expression = value;
  selectionStart = start;
  return genAction('PLATFORM_UI_FORMULA_INIT_DATA', { expression: expression, checkPass: false });
}

export function focus(value) {
  return function (dispatch) {
    selectionStart = value;
  }
}

export function check() {
  return async function (dispatch, getState) {
    // let result = null;
    // var exp = /{.*?}/g;
    // var items = expression.match(exp);
    // if (items) {
    //   result = expression.replace(exp, title => {
    //     return title2ResultKey[title] || title;
    //   });
    // } else {
    //   result = expression;
    // }
    const { custom } = getState().formula.toJS();
    const {iTplId,tpllist}  = getState().billDesign.toJS();
    let index = _.findIndex(tpllist,(v)=>{ return v.iTplId == iTplId})
    let iTplMode = null;
    if(index > -1){
      iTplMode = tpllist[index].iTplMode
    }
    let params = {
      billno: billNo,
      iBillEntityId: entityName,
      expression,
      iTplMode
    };
    if (custom.id) {
      params['id'] = custom.id;
    }

    const config = {
      url: 'billdesign/checkExpression',
      method: 'POST',
      params: params
    };
    const json = await proxy(config);
    if (json.code !== 200) {
      dispatch(genAction('PLATFORM_UI_FORMULA_INIT_DATA', { errorInfo: json.message, checkPass: false }));
      return;
    }
    if (json.data && json.data.bCanModify) {
      dispatch(getEnumMap());
    }
    cb.utils.alert('校验成功', 'success');
    dispatch(genAction('PLATFORM_UI_FORMULA_INIT_DATA', { cName: json.data.cName, bCanModify: json.data.bCanModify, expressionCode: json.data.expression, errorInfo: '', checkPass: true, cSensFieldName: json.data.cSensFieldName }));
  }
}

export function initOperator() {
  return async function (dispatch) {
    const config = {
      url: 'enum/getEnumStrFetch',
      method: 'GET',
      params: {
        enumtype: 'expressionType'
      }
    };
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert(json.message, 'error');
      return;
    }
    const operatorData = JSON.parse(json.data);
    dispatch(genAction('PLATFORM_UI_FORMULA_INIT_DATA', { operatorData }));
  }
}

export function initData(billno, data, entityname) {
  return async function (dispatch, getState) {
    let { custom } = getState().formula.toJS();
    if (billno !== billNo || entityname !== entityName) {
      billNo = billno;
      entityName = entityname;
      const config = {
        url: 'billdesign/getBillDataSource',
        method: 'GET',
        params: {
          billno: billNo,
          iBillEntityId: entityName
        }
      };
      const json = await proxy(config);
      if (json.code !== 200) {
        cb.utils.alert(json.message, 'error');
        return;
      }
      treeData = json.data;
      key2Data = {};
      selectedKey2Title = {};
      title2ResultKey = {};
      rebuildTreeData(treeData);
    }
    if (data) {
      expression = data.expression || '';
      selectionStart = expression && expression.length || 0;
    }
    dispatch(getEnumMap(data.custom));
    let controlType = data.cControlType && data.cControlType.trim().toLocaleLowerCase();
    let btCanModify = false;
    if (controlType === 'select' || controlType === 'refer') {
      dispatch(chooseEnumService(controlType));
      if (controlType === 'refer') {
        btCanModify = true;
      }
    }
    data.custom = Object.assign(custom, data.custom);
    if (!data.cControlType) {
      data.cControlType = "Input";
    }
    dispatch(genAction('PLATFORM_UI_FORMULA_INIT_DATA', Object.assign({ billNo, treeData, visible: true, bCanModify: btCanModify }, data)));
  }
}

export function close() {
  return genAction('PLATFORM_UI_FORMULA_INIT_DATA', {
    visible: false,
    caption: '',
    expression,
    expressionCode,
    errorInfo: '',
    checkPass: false,
    cControlType: 'Input',
    cFormatData: null,
    iNumPoint: 0,
  });
}

export function getEntityInfo(key) {
  return async function (dispatch) {
    const expandData = key2Data[key];
    const { entityName } = expandData;
    const config = {
      url: 'billdesign/getEntityInfoByName',
      method: 'GET',
      params: { entityName }
    };
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert(json.message, 'error');
      return;
    }
    expandData.children = json.data;
    key2Data = {};
    selectedKey2Title = {};
    title2ResultKey = {};
    rebuildTreeData(treeData);
    dispatch(genAction('PLATFORM_UI_FORMULA_INIT_DATA', { treeData }));
  }
}

function rebuildTreeData(data, mergeCode, mergeName) {
  data.forEach(item => {
    const codes = [], names = [];
    if (mergeCode)
      codes.push(mergeCode);
    codes.push(item.name);
    if (mergeName)
      names.push(mergeName);
    names.push(item.title);
    item.mergeCode = codes.join('.');
    key2Data[item.mergeCode] = item;
    item.mergeName = names.join('.');
    const mergeTitle = `[${item.mergeName}]`;
    selectedKey2Title[item.mergeCode] = mergeTitle;
    title2ResultKey[mergeTitle] = item.mergeCode;
    if (!item.children) return;
    rebuildTreeData(item.children, item.mergeCode, item.mergeName);
  });
}

function getEnumMap(data) {
  return async (dispatch) => {
    const config = {
      url: 'enum/getEnumMap',
      method: 'GET',
      params: {
        enumtype: 'aa_itemtype'
      }
    };
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert(json.message, 'error');
      return;
    }
    // json.data && this.setState({ filterTypedata: json.data });
    if (!data) {
      data = {}
    }
    dispatch(genAction('PLATFORM_ENUM_MERGE_DATA', Object.assign({ "enums": json.data }, data)));
  }
}

export function setCustomVal(data) {
  return (dispatch) => {
    dispatch(genAction('PLATFORM_ENUM_MERGE_DATA', data));
  }
}

export function chooseEnumService(enumType) {
  return async (dispatch) => {
    let config = {};
    if (enumType === 'select') {
      config = {
        url: 'filterDesign/getEnumList',
        method: 'GET',
        params: {

        }
      }
    } else {
      config = {
        url: 'pub/ref/getRefMeta',
        method: 'GET',
        params: {
          refCode: 'pub_refList'
        }
      }
    }
    const json = await proxy(config);
    if (json.code != 200) {
      cb.utils.alert(json.message, 'error');
      return;
    }
    dispatch(genAction('PLATFORM_ENUM_MERGE_DATA', { "data": json.data }));
  }
}

//根据选中参照请求数据
export function getreferdata(value) {
  return async (dispatch) => {
    const config = {
      url: 'filterDesign/getRefRetList',
      method: 'GET',
      params: { refCode: value }
    };
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert(json.message, 'error');
      return;
    }
    dispatch(genAction('PLATFORM_ENUM_MERGE_DATA', { "returnval": json.data }));
  }
}

export function clearEnumData() {
  return (dispatch) => {
    dispatch(genAction('PLATFORM_CLEAR_MERGE_DATA'));
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/redux/formula.jsx